import React, { useState } from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./watchlistWrappedContainer.module.css";
import { ZoneModule } from "~components/GridPhoenix/ZoneModule";
import { WatchlistWrapped } from "~components/WatchlistWrapped";
import { WatchlistWrappedPlaceholder } from "~components/WatchlistWrapped/WatchlistWrappedPlaceholder";
import { LazyLoad } from "~components/LazyLoad";

export function WatchlistWrappedContainer() {
  const [shouldApplyEmptyStateBg, setShouldApplyEmptyStateBg] = useState(false);

  const cx = createClasses({
    [styles.bundlesBg]: shouldApplyEmptyStateBg,
  });

  return (
    <ZoneModule className={cx}>
      <LazyLoad placeholder={<WatchlistWrappedPlaceholder />} onEnterDelay={0}>
        <WatchlistWrapped onBgChange={setShouldApplyEmptyStateBg} />
      </LazyLoad>
    </ZoneModule>
  );
}
